import React, { useContext } from 'react';
import { hasRichFormatting } from '../../../../helpers/rich_text';

import Context from '../../../../utils/context';
import RichText from '../../../core/ui/rich_text';
import styles from './index.module.css';

const renderRich = (value) => (hasRichFormatting(value) ? <RichText html={value} /> : value);

const LOGO_SRC = 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/svg/pp-logo.svg';

export default function QuestionnaireStopperV2({
  heading,
  body,
  detailed = false,
  onContinue,
  continueLabel = 'Continue',
}) {
  const context = useContext(Context);
  const isLoggedIn = Boolean(context && context.auth && context.auth.isLoggedIn());
  const rootClass = detailed ? `${styles.root} ${styles.rootDetailed}` : styles.root;

  return (
    <div className={rootClass}>
      <div className={styles.orbTop} aria-hidden='true' />
      <div className={styles.orbBottom} aria-hidden='true' />
      {!isLoggedIn && <img src={LOGO_SRC} alt='PatientPartner' className={styles.logo} draggable='false' />}
      <div className={styles.frame}>
        <div className={styles.textBlock}>
          {heading && <h1 className={styles.heading}>{renderRich(heading)}</h1>}
          {body && (
            <div className={detailed ? `${styles.body} ${styles.bodyDetailed}` : styles.body}>{renderRich(body)}</div>
          )}
          {onContinue && (
            <button type='button' className={styles.continueButton} onClick={onContinue}>
              {continueLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
